module.exports = __webpack_public_path__ + "img/5-3.19f2b1ce.jpg";